import { ajaxRequest, createCourse } from "../../Utils/Ajax/ajax";
import { hideModal, successToast } from "../../Utils/utils";


export function loadCourseCreation(){

    $(document).on("click", ".create-new-course",  function(){
        createCourse($(this));
    })

}


function createCourse(btn:JQuery){

    const longName = $("#course-name-long").val();

    const courseId = Number($("#course-id").val())

    const url = '/course/' + courseId.toString() + '/create'


    const data = {
        courseName: longName,
    }

    const success = function(data){
        $("#course-name-long").val("");
          hideModal('create-course-modal');
  
          const tutorModal = $(".create-tutor-modal");
          if (tutorModal != undefined){
            tutorModal.trigger('click');
          }
  
          successToast("Kurs " + longName + " wurde erstellt", "Erfolg", 2500, true);
  
          setTimeout(() =>{
            location.reload();
          }, 1250);   
    }

    ajaxRequest(url, success, data, btn)
  }